import React from 'react';
import {BrowserRouter, Switch, Route} from "react-router-dom";
import Terms from './screens/home/terms'
import Privacy from './screens/home/Privacy'
import Router from './Router'
import {Admin} from './screens/admin'
import {FumdyAdmin} from './screens/famdyAdmin'
import {Fun} from './screens/fun'
import Login from './screens/admin/login/login'
import OnePage from './screens/onePage/OnePage'
import 'aos/dist/aos.css';
import AOS from 'aos'

function App() {
    AOS.init()
    return (
      <BrowserRouter>
        <Switch>
            <Route path={"/mangarmangaagiinadmin"} component={Admin} />
            <Route path={"/mangarfamdygiinadmin"} component={FumdyAdmin} />
            <Route path={"/fun"} component={Fun} />
            <Route exact path={"/manaagiinloginheseg"} component={Login} />
            <Route exact path={"/"} component={OnePage} />
            <Route exact path={"/v2"} component={Router} />
            <Route exact path={"/terms"} component={Terms} />
            <Route exact path={"/privacy-policy"} component={Privacy} />
        </Switch>
      </BrowserRouter>
    );
}

export default App;
